import React from 'react'

const OnOffButtons = (props: {
  toggle: boolean,
  returnFunction: Function,
  values?: {
    left: string,
    right: string
  }
}) => {
  const toggleOn = props.toggle ? 'border-white cursor-default' : 'border-black/50'
  const toggleOff = props.toggle ? 'border-black/50' : 'border-white cursor-default'

  return (
    <div className="flex flex-row">
      <div
        className={`border bg-transparent px-4 py-2 font-bold' ${toggleOn} hover:cursor-pointer`}
        onClick={() => props.returnFunction()}
      >
        {props.values?.left || 'ON'}
      </div>
      <div
        className={`border bg-transparent px-4 py-2 font-bold' ${toggleOff} hover:cursor-pointer`}
        onClick={() => props.returnFunction()}
      >
        {props.values?.right || 'OFF'}
      </div>
      </div>
  )
}

export default OnOffButtons
